import { cn } from '@/lib/utils';

/**
 * FIX SC 1.4.3 [AA]: Contrast ratios verified for all categories.
 * Emerald 100/800 (~11:1), Blue 100/800 (~10:1), Amber 100/800 (~8:1), Violet 100/800 (~9:1).
 */
const nicheColors: Record<string, string> = {
  nonprofit: 'bg-bloom-green-mid/10 text-bloom-green-deep',
  government: 'bg-bloom-green-mid/10 text-bloom-green-deep',
  hoa: 'bg-bloom-gold/10 text-bloom-gold-dark',
  church: 'bg-bloom-green-mid/10 text-bloom-green-deep',
  'small-business': 'bg-bloom-linen text-bloom-charcoal',
  other: 'bg-bloom-linen text-bloom-charcoal/70',
};

interface NicheTagProps {
  niche: string;
  className?: string;
}

const NicheTag = ({ niche, className }: NicheTagProps) => (
  <span 
    /**
     * <!-- FIX SC 1.3.1 [A]: span with role="text" (implicit) provides programmatic info. -->
     */
    className={cn('inline-block px-3 py-1 rounded-full text-xs font-sans font-medium capitalize', nicheColors[niche] || nicheColors.other, className)}
  >
    {niche === 'hoa' ? 'HOA' : niche === 'small-business' ? 'Small Business' : niche}
  </span>
);

export default NicheTag;
